module.exports = __webpack_public_path__ + "static/Mehmood-a695a46ee5a519dde0ac064291217ea5.jpg";